import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { saveLastVisitedPage } from '../utils/lastPageTracker';

/**
 * Hook per il tracking automatico delle pagine visitate
 * Salva automaticamente ogni cambio di route nel localStorage
 */
const usePageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Salva la pagina corrente quando cambia la location
    saveLastVisitedPage(location.pathname, location.search);
  }, [location.pathname, location.search]);
};

export default usePageTracker;